module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('user.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "form",
      fn: function(props) {
        return [_c('v-card-title', {
          staticClass: "headline"
        }, [_c('v-icon', [_vm._v(_vm._s(_vm.form.id ? 'person' : 'person_add'))]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('user.crud.editUser') : _vm.$t('user.crud.addUser')) + "\n            "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal')
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
          ref: "form",
          attrs: {
            "lazy-validation": ""
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.save($event)
            }
          },
          model: {
            value: (_vm.valid),
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        }, [(_vm.form.usuario == _vm.usuario && _vm.form.id) ? _c('v-alert', {
          attrs: {
            "color": "info",
            "value": "true"
          }
        }, [_vm._v("\n              Puede cambiar su contraseña yendo a:\n              "), _c('router-link', {
          staticClass: "white--text",
          attrs: {
            "to": "/account"
          }
        }, [_c('strong', [_c('v-icon', {
          staticClass: "icon-small",
          attrs: {
            "dark": ""
          }
        }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.$t('app.account')))], 1)]), _vm._v(".\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
          attrs: {
            "grid-list-md": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre de usuario",
            "prepend-icon": "person",
            "maxlength": "50",
            "autocomplete": "off",
            "rules": _vm.$validate(['required']),
            "required": "",
            "autofocus": ""
          },
          model: {
            value: (_vm.form.usuario),
            callback: function($$v) {
              _vm.$set(_vm.form, "usuario", $$v)
            },
            expression: "form.usuario"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [(!_vm.form.id) ? _c('v-text-field', {
          attrs: {
            "label": "Contraseña",
            "prepend-icon": _vm.getIcon,
            "prepend-icon-cb": _vm.changeIcon,
            "type": _vm.hidePass ? 'password' : 'text',
            "maxlength": "50",
            "autocomplete": "off",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.contrasena),
            callback: function($$v) {
              _vm.$set(_vm.form, "contrasena", $$v)
            },
            expression: "form.contrasena"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre(s)",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.nombres),
            callback: function($$v) {
              _vm.$set(_vm.form, "nombres", $$v)
            },
            expression: "form.nombres"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Primer apellido",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.primer_apellido),
            callback: function($$v) {
              _vm.$set(_vm.form, "primer_apellido", $$v)
            },
            expression: "form.primer_apellido"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Segundo apellido",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.segundo_apellido),
            callback: function($$v) {
              _vm.$set(_vm.form, "segundo_apellido", $$v)
            },
            expression: "form.segundo_apellido"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Cargo",
            "maxlength": "255"
          },
          model: {
            value: (_vm.form.cargo),
            callback: function($$v) {
              _vm.$set(_vm.form, "cargo", $$v)
            },
            expression: "form.cargo"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-select', {
          attrs: {
            "label": "Regional",
            "items": _vm.regionales,
            "chips": "",
            "attach": "",
            "multiple": ""
          },
          model: {
            value: (_vm.regionalesSeleccionadas),
            callback: function($$v) {
              _vm.regionalesSeleccionadas = $$v
            },
            expression: "regionalesSeleccionadas"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Correo electrónico",
            "maxlength": "100",
            "prepend-icon": "email",
            "rules": _vm.$validate(['email'])
          },
          model: {
            value: (_vm.form.email),
            callback: function($$v) {
              _vm.$set(_vm.form, "email", $$v)
            },
            expression: "form.email"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs4": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Teléfono",
            "prepend-icon": "phone",
            "maxlength": "30"
          },
          model: {
            value: (_vm.form.telefono),
            callback: function($$v) {
              _vm.$set(_vm.form, "telefono", $$v)
            },
            expression: "form.telefono"
          }
        })], 1), _vm._v(" "), (_vm.$store.state.user.id_rol != 5) ? _c('v-flex', {
          attrs: {
            "xs7": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.entidades,
            "label": "Entidad",
            "item-text": "text",
            "item-value": "value",
            "autocomplete": "",
            "noDataText": "No hay resultados",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.id_entidad),
            callback: function($$v) {
              _vm.$set(_vm.form, "id_entidad", $$v)
            },
            expression: "form.id_entidad"
          }
        })], 1) : _vm._e(), _vm._v(" "), (!(_vm.form.usuario == _vm.usuario && _vm.form.id)) ? _c('v-flex', {
          attrs: {
            "xs5": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.roles,
            "label": "Rol",
            "item-text": "text",
            "item-value": "id",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.id_rol),
            callback: function($$v) {
              _vm.$set(_vm.form, "id_rol", $$v)
            },
            expression: "form.id_rol"
          }
        })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
          staticClass: "error--text text-required"
        }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal');
            }
          }
        }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "type": "submit"
          }
        }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')))], 1)], 1)], 1)]
      }
    }, {
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['usuarios:update'] && items.item.id_rol != 8) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'usuario', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['usuarios:update'] && _vm.$store.state.user.id_rol == 1) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Restablecer contraseña")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['usuarios:delete'] && items.item.id_rol != 8 && _vm.usuario !== items.item.usuario) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'usuario')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['usuarios:update'] && items.item.id_rol != 8) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.usuario !== items.item.usuario) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'usuario', 'EditUsuario')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.permissions['usuarios:update'] && _vm.usuario !== items.item.usuario) ? _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.usuario === items.item.usuario) ? _c('router-link', {
          attrs: {
            "slot": "activator",
            "to": "/account"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("person")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Este usuario soy yo, clic aquí para ir a mi cuenta.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.usuario))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.primer_apellido) + " " + _vm._s(items.item.segundo_apellido) + " " + _vm._s(items.item.nombres))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.entidad_nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.rol_nombre))]), _vm._v(" "), _c('td', _vm._l((items.item.departamento.split(',')), function(item) {
          return _c('span', [_vm._v("\n              " + _vm._s(item)), _c('br')])
        }), 0), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['usuarios:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person_add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('user.add')))])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3152fb66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/usuario/Usuario.vue
// module id = 507
// module chunks = 2